import React from "react";
import PropTypes from "prop-types";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import "./userEditor.css";

const modules = {
  toolbar: [
    [{ font: [] }],
    ["bold", "italic", "underline", "strike"], // toggled buttons
    ["blockquote", "code-block"],

    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }], // superscript/subscript
    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    [{ direction: "rtl" }], // text direction

    [{ size: ["small", false, "large", "huge"] }], // custom dropdown
    [{ header: [1, 2, 3, 4, 5, 6, false] }],

    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ align: [] }],
    ["link", "image"],

    ["clean"] // remove formatting button
  ]
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image"
];

const UserEditor = ({ value, onChange, className, disableHeader, noBorder, ...restProps }) => (
  <ReactQuill
    className={`editor ${className} ${disableHeader && "disabled"} ${noBorder && "no-border"}`}
    formats={formats}
    modules={modules}
    onChange={onChange}
    value={value}
    {...restProps}
  />
);

UserEditor.defaultProps = {
  onChange: () => {},
  value: "",
  className: "",
  disableHeader: false,
  noBorder: false
};

UserEditor.propTypes = {
  className: PropTypes.string,
  disableHeader: PropTypes.bool,
  noBorder: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string
};

export default UserEditor;
